import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalSize } from 'components/notifications';
import { Button, LinkButton } from 'components/buttons';
import { ShowHide } from 'components/layout';

const defaultFunction = () => {};

export function DefectDetailsModal(
    {
        isOpen = false,
        title = "Defect Details",
        updateStatusHref = null,
        onUpdateStatus = null,
        onClose = defaultFunction,
        children = null
    }
) {
    let updateStatusButton = null;

    if (updateStatusHref) {
        updateStatusButton = <LinkButton text="Update status" icon="edit" intent="primary" externalLink href={updateStatusHref} id="defect-details-update-status" />;
    } else if (onUpdateStatus) {
        updateStatusButton = <Button text="Update status" icon="edit" intent="primary" onClick={onUpdateStatus} id="defect-details-update-status" />;
    }

    let footer = null;

    if (updateStatusButton) {
        footer = (
            <div className="inline-items inline-items-end">
                {updateStatusButton}
            </div>
        );
    }

    return (
        <Modal
            title={title}
            isOpen={isOpen}
            onClose={onClose}
            size={ModalSize.MEDIUM}
            footer={footer}
        >
            <div className="defect-details">
                <ShowHide
                    evaluator={children != null}
                    show={children}
                />
            </div>
        </Modal>
    );
}

DefectDetailsModal.propTypes = {
    isOpen: PropTypes.bool,
    title: PropTypes.string,
    updateStatusHref: PropTypes.string,
    onUpdateStatus: PropTypes.func,
    onClose: PropTypes.func,
    children: PropTypes.node
};
